import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './css/Components.css';
import App from './App';
import Admin from './Admin';

const isAdminPath =
  window.location.pathname === '/admin' ||
  window.location.pathname === '/admin/';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isAdminPath ? <Admin /> : <App />}
  </React.StrictMode>
);

